import {getRequest, postRequest} from './axios.js'
const API_HOST = window.yunweiConfig.apiUrl;

export const oldVersionList = params => {
  return getRequest({
    path: API_HOST + '/api/sign/app/oldVersionList',
    params: params
  })
}

export const oldVersionInfo = params => {
  return getRequest({
    path: API_HOST + '/api/sign/app/oldVersionInfo',
    params: params
  })
}

export const makeSign = (params, headers, isNew = true) => {
  let path = API_HOST + '/api/sign/' + (isNew ? 'firstNewStep' : 'firstStep')
  return postRequest({
    path: path,
    params: params,
    headers: headers
  })
}

export const checkProgress = (params, headers) => {
  let path = API_HOST + '/api/sign/getProgressStep'
  return postRequest({
    path: path,
    params: params,
    headers: headers
  })
}



// WEBPACK FOOTER //
// ./src/service/api.js